import { Component } from "react";
import { render } from "react-dom";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
//import Slider from "react-rangeslider";
//import "react-rangeslider/lib/index.css";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import Select from "react-select";

import { MDBInput } from "mdb-react-ui-kit";

class vehicleFormView extends Component<any, any> {
  stepper: any;
  constructor(props: any) {
    super(props);
    this.state = {
      selectedIndex: 0,
    };
  }

  handleSelect = (index: any) => {
    this.setState({ selectedIndex: index });
  };

  render() {
    const options: any = [
      { value: "liter", label: "Liter" },
      { value: "gallon", label: "Gallon" },
    ];
    console.log("weeks props", this.props.selectedweeks);

    const startTimecharge = (
      <div className="col-3">
        <div className="form-group">
          <label title="Gasoline travelable distance unit">
            Charging start time
          </label>
          <input
            type="time"
            id="charge_prof_SrT"
            className="form-control"
            value={this.props.vehicalStateData.charge_prof_SrT}
            onChange={(e) => {
              this.props.changeHandler(
                e.currentTarget.value,
                e.currentTarget.id,
              );
            }}
          />
        </div>
      </div>
    );

    const endTimecharge = (
      <div className="col-3">
        <div className="form-group">
          <label title="Gasoline travelable distance unit">
            Charging Stop time
          </label>
          <input
            type="time"
            id="charge_prof_SoT"
            className="form-control"
            value={this.props.vehicalStateData.charge_prof_SoT}
            onChange={(e) => {
              this.props.changeHandler(
                e.currentTarget.value,
                e.currentTarget.id,
              );
            }}
          />
        </div>
      </div>
    );

    const startTimeNext = (
      <div className="col-3">
        <div className="form-group">
          <label title="Gasoline travelable distance unit">
            Charging start time of next timer
          </label>
          <input
            type="time"
            id="charge_sdl_chrgST"
            className="form-control"
            value={this.props.vehicalStateData.charge_sdl_chrgST}
            onChange={(e) => {
              this.props.changeHandler(
                e.currentTarget.value,
                e.currentTarget.id,
              );
            }}
          />
        </div>
      </div>
    );

    const endTimeNext = (
      <div className="col-3">
        <div className="form-group">
          <label title="Gasoline travelable distance unit">
            Charging end time of next timer
          </label>
          <input
            type="time"
            id="charge_sdl_chrgET"
            className="form-control"
            value={this.props.vehicalStateData.charge_sdl_chrgET}
            onChange={(e) => {
              this.props.changeHandler(
                e.currentTarget.value,
                e.currentTarget.id,
              );
            }}
          />
        </div>
      </div>
    );

    console.log(
      "check val change",
      this.props.vehicalStateData.charge_sdl_setTyp,
    );

    return (
      <div className="col-6">
        <div className="form_model bg-white shadow-3 p-3">
          <form onSubmit={this.props.onSubmit}>
            <Tabs
              selectedIndex={this.state.selectedIndex}
              onSelect={this.handleSelect}
            >
              <TabList>
                <Tab>Key Resource Status</Tab>
                <Tab>Health Status</Tab>
                <Tab>Extended Openings</Tab>
                <Tab>Seat Arrangement</Tab>
                <Tab>E-Connect</Tab>
                <Tab>Climate Control</Tab>
              </TabList>
              <TabPanel>
                <div className="status_sections">
                  <h5 className="fs-6 border-bottom pb-2 d-none">
                    Door Status
                  </h5>
                  <div className="row py-3">
                    <div className="col-3">
                      <div className="form-group">
                        <label>Front Door Left (FDL)</label>
                        <input
                          type="checkbox"
                          id="FDL-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("door_FDL");
                          }}
                          checked={
                            this.props.vehicalStateData.door_FDL ? true : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="FDL-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">LOCK</div>
                        <div className="unlock">UNLOCK</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Front Door Right (FDR)</label>
                        <input
                          type="checkbox"
                          id="FDR-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("door_FDR");
                          }}
                          checked={
                            this.props.vehicalStateData.door_FDR ? true : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="FDR-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">LOCK</div>
                        <div className="unlock">UNLOCK</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Rear Door Left (RDL) </label>
                        <input
                          type="checkbox"
                          id="RDL-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("door_RDL");
                          }}
                          checked={
                            this.props.vehicalStateData.door_RDL ? true : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="RDL-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">LOCK</div>
                        <div className="unlock">UNLOCK</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Rear Door Right (RDR)</label>
                        <input
                          type="checkbox"
                          id="RDR-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("door_RDR");
                          }}
                          checked={
                            this.props.vehicalStateData.door_RDR ? true : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="RDR-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">LOCK</div>
                        <div className="unlock">UNLOCK</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group mt-3">
                        <label>Front Door Left (FDL)</label>
                        <input
                          type="checkbox"
                          id="ocFDL-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("oC_door_FDL");
                          }}
                          checked={
                            this.props.vehicalStateData.oC_door_FDL
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="ocFDL-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">Close</div>
                        <div className="unlock">Open</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group mt-3">
                        <label>Front Door Right (FDR)</label>
                        <input
                          type="checkbox"
                          id="ocFDR-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("oC_door_FDR");
                          }}
                          checked={
                            this.props.vehicalStateData.oC_door_FDR
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="ocFDR-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">Close</div>
                        <div className="unlock">Open</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group mt-3">
                        <label>Rear Door Left (RDL) </label>
                        <input
                          type="checkbox"
                          id="ocRDL-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("oC_door_RDL");
                          }}
                          checked={
                            this.props.vehicalStateData.oC_door_RDL
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="ocRDL-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">Close</div>
                        <div className="unlock">Open</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group mt-3">
                        <label>Rear Door Right (RDR)</label>
                        <input
                          type="checkbox"
                          id="ocRDR-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("oC_door_RDR");
                          }}
                          checked={
                            this.props.vehicalStateData.oC_door_RDR
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="ocRDR-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">Close</div>
                        <div className="unlock">Open</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="status_sections">
                  <h5 className="fs-6 border-bottom pb-2 d-none">
                    Cabin Status
                  </h5>
                  <div className="row py-3">
                    <div className="col-3">
                      <div className="form-group">
                        <label>Cabin Status</label>
                        <input
                          type="checkbox"
                          id="FCD-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("cabin_outSts");
                          }}
                          checked={
                            this.props.vehicalStateData.cabin_outSts
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="FCD-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">LOCK</div>
                        <div className="unlock">UNLOCK</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Rear Seat Reminder</label>
                        <input
                          type="checkbox"
                          id="RCD-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("seat_RStRem");
                          }}
                          checked={
                            this.props.vehicalStateData.seat_RStRem
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="RCD-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">On</div>
                        <div className="unlock">Off</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Engine</label>
                        <input
                          type="checkbox"
                          id="FE-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("engine_sts");
                          }}
                          checked={
                            this.props.vehicalStateData.engine_sts
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="FE-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">On</div>
                        <div className="unlock">Off</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>SVT Request</label>
                        <input
                          type="checkbox"
                          id="svt-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("svt");
                          }}
                          checked={
                            this.props.vehicalStateData.svt ? true : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="svt-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">True</div>
                        <div className="unlock">False</div>
                      </div>
                    </div>
                    <h5 className="fs-6 border-bottom pb-2 mt-4">Alerts</h5>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Horn</label>
                        <input
                          type="checkbox"
                          id="alerts_Horn-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("alerts_Horn");
                          }}
                          checked={
                            this.props.vehicalStateData.alerts_Horn
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="alerts_Horn-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">On</div>
                        <div className="unlock">Off</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Buzzer</label>
                        <input
                          type="checkbox"
                          id="alerts_Buzzer-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("alerts_Buzzer");
                          }}
                          checked={
                            this.props.vehicalStateData.alerts_Buzzer
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="alerts_Buzzer-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">On</div>
                        <div className="unlock">Off</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Hazards</label>
                        <input
                          type="checkbox"
                          id="alerts_Hazards-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("alerts_Hazards");
                          }}
                          checked={
                            this.props.vehicalStateData.alerts_Hazards
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="alerts_Hazards-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">On</div>
                        <div className="unlock">Off</div>
                      </div>
                    </div>
                    <h5 className="fs-6 border-bottom pb-2 mt-4">
                      Precondition
                    </h5>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Key Detected</label>
                        <input
                          type="checkbox"
                          id="keydetected-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("keydetected");
                          }}
                          checked={
                            this.props.vehicalStateData.keydetected
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="keydetected-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">True</div>
                        <div className="unlock">False</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Kleg Confirmation</label>
                        <input
                          type="checkbox"
                          id="klegconfirmation-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("klegconfirmation");
                          }}
                          checked={
                            this.props.vehicalStateData.klegconfirmation
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="klegconfirmation-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">True</div>
                        <div className="unlock">False</div>
                      </div>
                    </div>
                    <h5 className="fs-6 border-bottom pb-2 mt-4">Lamps</h5>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Head Lamp</label>
                        <input
                          type="checkbox"
                          id="lamps_FL-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("lamps_FL");
                          }}
                          checked={
                            this.props.vehicalStateData.lamps_FL ? true : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="lamps_FL-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">On</div>
                        <div className="unlock">Off</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Tail Lamp</label>
                        <input
                          type="checkbox"
                          id="lamps_RL-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("lamps_RL");
                          }}
                          checked={
                            this.props.vehicalStateData.lamps_RL ? true : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="lamps_RL-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">On</div>
                        <div className="unlock">Off</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Hazards</label>
                        <input
                          type="checkbox"
                          id="lamps_Hazards-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("lamps_Hazards");
                          }}
                          checked={
                            this.props.vehicalStateData.lamps_Hazards
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="lamps_Hazards-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">On</div>
                        <div className="unlock">Off</div>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="status_sections">
                  <h5 className="fs-6 border-bottom pb-2 d-none">
                    Cabin Status
                  </h5>
                  <div className="row py-3">
                    <div className="col-3">
                      <div className="form-group mb-0">
                        <label>Fuel Status</label>
                        <Select
                          value={this.props.selectedOption}
                          defaultValue={this.props.selectedOption}
                          onChange={this.props.volumehandleChange}
                          options={options}
                          className="cutomstyleselect"
                        />
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.health_fuel_Sts}
                          onChange={(value) => {
                            this.props.changeHandler(value, "health_fuel_Sts");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_fuel_Sts}{" "}
                          {this.props.selectfinaldata}
                        </div>
                        {/* <input type="number" id="health_fuel_Sts" className="form-control" value={this.props.vehicalStateData.health_fuel_Sts} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group mb-0">
                        <label>Charge Level</label>
                        <Slider
                          min={0}
                          max={100}
                          value={
                            this.props.vehicalStateData.health_fuel_Lvl_chrg
                          }
                          onChange={(value) => {
                            this.props.changeHandler(
                              value,
                              "health_fuel_Lvl_chrg",
                            );
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_fuel_Lvl_chrg} %
                        </div>
                        {/* <input type="text" id="health_fuel_Lvl_chrg" className="form-control" value={this.props.vehicalStateData.health_fuel_Lvl_chrg} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group mb-0">
                        <label>Gas Level</label>
                        <Slider
                          min={0}
                          max={100}
                          value={
                            this.props.vehicalStateData.health_fuel_Lvl_gas
                          }
                          onChange={(value) => {
                            this.props.changeHandler(
                              value,
                              "health_fuel_Lvl_gas",
                            );
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_fuel_Lvl_gas} %
                        </div>
                        {/* <input type="text" id="health_fuel_Lvl_gas" className="form-control" value={this.props.vehicalStateData.health_fuel_Lvl_gas} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group mb-0">
                        <label>Hydrogen Level</label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.health_fuel_Lvl_h2}
                          onChange={(value) => {
                            this.props.changeHandler(
                              value,
                              "health_fuel_Lvl_h2",
                            );
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_fuel_Lvl_h2} %
                        </div>
                        {/* <input type="text" id="health_fuel_Lvl_h2" className="form-control" value={this.props.vehicalStateData.health_fuel_Lvl_h2} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group mb-0">
                        <label>Total Range</label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.health_DTE_tot}
                          onChange={(value) => {
                            this.props.changeHandler(value, "health_DTE_tot");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_DTE_tot} %
                        </div>
                        {/* <input type="text" id="health_DTE_tot" className="form-control" value={this.props.vehicalStateData.health_DTE_tot} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group mb-0">
                        <label>EV Range</label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.health_DTE_ev}
                          onChange={(value) => {
                            this.props.changeHandler(value, "health_DTE_ev");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_DTE_ev} %
                        </div>
                        {/* <input type="text" id="health_DTE_ev" className="form-control" value={this.props.vehicalStateData.health_DTE_ev} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group mb-0">
                        <label>Gas Range</label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.health_DTE_gas}
                          onChange={(value) => {
                            this.props.changeHandler(value, "health_DTE_gas");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_DTE_gas} %
                        </div>
                        {/* <input type="text" id="health_DTE_gas" className="form-control" value={this.props.vehicalStateData.health_DTE_gas} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group mb-0">
                        <label>Hydrogen Range</label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.health_DTE_h2}
                          onChange={(value) => {
                            this.props.changeHandler(value, "health_DTE_h2");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_DTE_h2} %
                        </div>
                        {/* <input type="text" id="health_DTE_h2" className="form-control" value={this.props.vehicalStateData.health_DTE_h2} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="form-group">
                        <label title="Gasoline travelable distance unit">
                          Gasoline travelable distance unit
                        </label>
                        <input
                          type="text"
                          id="health_DTE_GTDU"
                          className="form-control"
                          value={this.props.vehicalStateData.health_DTE_GTDU}
                          onChange={(e) => {
                            this.props.changeHandler(
                              e.currentTarget.value,
                              e.currentTarget.id,
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="form-group">
                        <label title="EV travelable distance subtraction rate">
                          EV travelable distance subtraction rate
                        </label>
                        <input
                          type="text"
                          id="health_DTE_evTDstSR"
                          className="form-control"
                          value={
                            this.props.vehicalStateData.health_DTE_evTDstSR
                          }
                          onChange={(e) => {
                            this.props.changeHandler(
                              e.currentTarget.value,
                              e.currentTarget.id,
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="form-group">
                        <label title="Power Supply Possible Time by Gasoline">
                          Power Supply Possible Time by Gasoline
                        </label>
                        <input
                          type="text"
                          id="health_DTE_PS_GPSPT"
                          className="form-control"
                          value={
                            this.props.vehicalStateData.health_DTE_PS_GPSPT
                          }
                          onChange={(e) => {
                            this.props.changeHandler(
                              e.currentTarget.value,
                              e.currentTarget.id,
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="form-group">
                        <label title="Power Supply Possible Time by slr">
                          Power Supply Possible Time by slr
                        </label>
                        <input
                          type="text"
                          id="health_DTE_PS_slr"
                          className="form-control"
                          value={this.props.vehicalStateData.health_DTE_PS_slr}
                          onChange={(e) => {
                            this.props.changeHandler(
                              e.currentTarget.value,
                              e.currentTarget.id,
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="form-group">
                        <label title="Power Supply Possible Time by Battery">
                          Power Supply Possible Time by Battery
                        </label>
                        <input
                          type="text"
                          id="health_DTE_PS_BPSPT"
                          className="form-control"
                          value={
                            this.props.vehicalStateData.health_DTE_PS_BPSPT
                          }
                          onChange={(e) => {
                            this.props.changeHandler(
                              e.currentTarget.value,
                              e.currentTarget.id,
                            );
                          }}
                        />
                      </div>
                    </div>
                    <h5 className="fs-6 border-bottom pb-2 mt-2 mb-3">
                      Odo Meter (KiloMeters/Liter)
                    </h5>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Life Time</label>
                        <input
                          type="text"
                          id="health_odo_lfTm"
                          className="form-control"
                          value={this.props.vehicalStateData.health_odo_lfTm}
                          onChange={(e) => {
                            this.props.changeHandler(
                              e.currentTarget.value,
                              e.currentTarget.id,
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Trip A Information</label>
                        <input
                          type="text"
                          id="health_odo_tripA"
                          className="form-control"
                          value={this.props.vehicalStateData.health_odo_tripA}
                          onChange={(e) => {
                            this.props.changeHandler(
                              e.currentTarget.value,
                              e.currentTarget.id,
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Trip B Information</label>
                        <input
                          type="text"
                          id="health_odo_tripB"
                          className="form-control"
                          value={this.props.vehicalStateData.health_odo_tripB}
                          onChange={(e) => {
                            this.props.changeHandler(
                              e.currentTarget.value,
                              e.currentTarget.id,
                            );
                          }}
                        />
                      </div>
                    </div>
                    <h5 className="fs-6 border-bottom pb-2 mt-2 mb-3">
                      Fuel Economy (Miles/Gallon)
                    </h5>
                    <div className="col-3">
                      <div className="form-group mb-0">
                        <label>Average</label>
                        <Slider
                          min={0}
                          max={100}
                          value={
                            this.props.vehicalStateData.health_fuelEco_lstTrip
                          }
                          onChange={(value) => {
                            this.props.changeHandler(
                              value,
                              "health_fuelEco_lstTrip",
                            );
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_fuelEco_lstTrip}
                        </div>

                        {/* <input type="text" id="health_fuelEco_lstTrip" className="form-control" value={this.props.vehicalStateData.health_fuelEco_lstTrip} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group mb-0">
                        <label title="Total Average fuel Economy">
                          Life Time
                        </label>
                        <Slider
                          min={0}
                          max={100}
                          value={
                            this.props.vehicalStateData.health_fuelEco_lfTm
                          }
                          onChange={(value) => {
                            this.props.changeHandler(
                              value,
                              "health_fuelEco_lfTm",
                            );
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_fuelEco_lfTm}
                        </div>
                        {/* <input type="text" id="health_fuelEco_lfTm" className="form-control" value={this.props.vehicalStateData.health_fuelEco_lfTm} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                    <h5 className="fs-6 border-bottom pb-2 mt-2 mb-3">
                      Tire Pressure
                    </h5>
                    <div className="col-6">
                      <div className="form-group mb-0">
                        <label title="Front Left Tire Pressure">
                          Front Left
                        </label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.health_TP_FLTP}
                          onChange={(value) => {
                            this.props.changeHandler(value, "health_TP_FLTP");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_TP_FLTP} PSI
                        </div>
                        {/* <input type="text" id="health_TP_FLTP" className="form-control" value={this.props.vehicalStateData.health_TP_FLTP} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group mb-0">
                        <label title="Front Right Tire Pressure">
                          Front Right
                        </label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.health_TP_FRTP}
                          onChange={(value) => {
                            this.props.changeHandler(value, "health_TP_FRTP");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_TP_FRTP} PSI
                        </div>
                        {/* <input type="text" id="health_TP_FRTP" className="form-control" value={this.props.vehicalStateData.health_TP_FRTP} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group mb-0">
                        <label title="Rear left Tire Pressure">Rear left</label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.health_TP_RLTP}
                          onChange={(value) => {
                            this.props.changeHandler(value, "health_TP_RLTP");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_TP_RLTP} PSI
                        </div>
                        {/* <input type="text" id="health_TP_RLTP" className="form-control" value={this.props.vehicalStateData.health_TP_RLTP} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group mb-0">
                        <label title="Rear Right Tire Pressure">
                          Rear Right
                        </label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.health_TP_RRTP}
                          onChange={(value) => {
                            this.props.changeHandler(value, "health_TP_RRTP");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_TP_RRTP} PSI
                        </div>
                        {/* <input type="text" id="health_TP_RRTP" className="form-control" value={this.props.vehicalStateData.health_TP_RRTP} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group mb-0">
                        <label title="Spare Tire Pressure">Spare Tire</label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.health_TP_STP}
                          onChange={(value) => {
                            this.props.changeHandler(value, "health_TP_STP");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_TP_STP} PSI
                        </div>
                        {/* <input type="text" id="health_TP_STP" className="form-control" value={this.props.vehicalStateData.health_TP_STP} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>

                    <h5 className="fs-6 border-bottom pb-2 mt-2 mb-3">
                      Battery
                    </h5>
                    <div className="col-3">
                      <div className="form-group mb-0">
                        <label title="Regular Battery Status">
                          Regular Battery Status
                        </label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.health_battery_sts}
                          onChange={(value) => {
                            this.props.changeHandler(
                              value,
                              "health_battery_sts",
                            );
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_battery_sts} %
                        </div>
                        {/* <input type="text" id="health_battery_sts" className="form-control" value={this.props.vehicalStateData.health_battery_sts} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>

                    <div className="col-3">
                      <div className="form-group mb-0">
                        <label>Key Fob Battery</label>
                        <Slider
                          min={0}
                          max={100}
                          value={
                            this.props.vehicalStateData.health_battery_Keyfob
                          }
                          onChange={(value) => {
                            this.props.changeHandler(
                              value,
                              "health_battery_Keyfob",
                            );
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_battery_Keyfob} %
                        </div>
                        {/* <input type="text" id="health_battery_Keyfob" className="form-control" value={this.props.vehicalStateData.health_battery_Keyfob} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                    <h5 className="fs-6 border-bottom pb-2 mt-2 mb-3">Oil</h5>
                    <div className="col-3">
                      <div className="form-group mb-0">
                        <label>Oil Life Time</label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.health_oil_lfTm}
                          onChange={(value) => {
                            this.props.changeHandler(value, "health_oil_lfTm");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.health_oil_lfTm} %
                        </div>
                        {/* <input type="text" id="health_oil_lfTm" className="form-control" value={this.props.vehicalStateData.health_oil_lfTm} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="status_sections">
                  <div className="row py-3">
                    <h5 className="fs-6 border-bottom pb-2 mt-3 mb-3">Trunk</h5>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Luggage compartment courtesy State</label>
                        <input
                          type="checkbox"
                          id="extendedOpenings_trunk-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("extendedOpenings_trunk");
                          }}
                          checked={
                            this.props.vehicalStateData.extendedOpenings_trunk
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="extendedOpenings_trunk-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">Open</div>
                        <div className="unlock">Close</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Door Courtesy State</label>
                        <input
                          type="checkbox"
                          id="extendedOpenings_trunks-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("extendedOpenings_trunks");
                          }}
                          checked={
                            this.props.vehicalStateData.extendedOpenings_trunks
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="extendedOpenings_trunks-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">Open</div>
                        <div className="unlock">Close</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Door Lock State</label>
                        <input
                          type="checkbox"
                          id="extendedOpenings_trunkl-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("extendedOpenings_trunkl");
                          }}
                          checked={
                            this.props.vehicalStateData.extendedOpenings_trunkl
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="extendedOpenings_trunkl-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">Lock</div>
                        <div className="unlock">Unlock</div>
                      </div>
                    </div>
                    <h5 className="fs-6 border-bottom pb-2 mt-3 mb-3">Hatch</h5>
                    <div className="col-3">
                      <div className="form-group">
                        <input
                          type="checkbox"
                          id="extendedOpenings_hatch-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("extendedOpenings_hatch");
                          }}
                          checked={
                            this.props.vehicalStateData.extendedOpenings_hatch
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="extendedOpenings_hatch-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">Lock</div>
                        <div className="unlock">Unlock</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <input
                          type="checkbox"
                          id="extendedOpenings_hatchs-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("extendedOpenings_hatchs");
                          }}
                          checked={
                            this.props.vehicalStateData.extendedOpenings_hatchs
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="extendedOpenings_hatchs-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">Open</div>
                        <div className="unlock">Close</div>
                      </div>
                    </div>
                    <h5 className="fs-6 border-bottom pb-2 mt-3 mb-3">
                      Tailgate
                    </h5>
                    <div className="col-3">
                      <div className="form-group">
                        <input
                          type="checkbox"
                          id="extendedOpenings_tailgate-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1(
                              "extendedOpenings_tailgate",
                            );
                          }}
                          checked={
                            this.props.vehicalStateData
                              .extendedOpenings_tailgate
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="extendedOpenings_tailgate-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">Lock</div>
                        <div className="unlock">Unlock</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <input
                          type="checkbox"
                          id="extendedOpenings_tailgates-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1(
                              "extendedOpenings_tailgates",
                            );
                          }}
                          checked={
                            this.props.vehicalStateData
                              .extendedOpenings_tailgates
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="extendedOpenings_tailgates-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">Open</div>
                        <div className="unlock">Close</div>
                      </div>
                    </div>
                    <h5 className="fs-6 border-bottom pb-2 mt-3 mb-3">Hood</h5>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Door Courtesy State</label>
                        <input
                          type="checkbox"
                          id="extendedOpenings_hood-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("extendedOpenings_hood");
                          }}
                          checked={
                            this.props.vehicalStateData.extendedOpenings_hood
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="extendedOpenings_hood-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">Open</div>
                        <div className="unlock">Close</div>
                      </div>
                    </div>

                    <h5 className="fs-6 border-bottom pb-2 mt-3 mb-3">Roof</h5>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Position of Slide Roof</label>
                        <input
                          type="checkbox"
                          id="extendedOpenings_roof-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("extendedOpenings_roof");
                          }}
                          checked={
                            this.props.vehicalStateData.extendedOpenings_roof
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="extendedOpenings_roof-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">Open</div>
                        <div className="unlock">Close</div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Soft Top Roof State</label>
                        <input
                          type="checkbox"
                          id="extendedOpenings_roofs-checkbox"
                          className="doorinput"
                          onClick={(e) => {
                            this.props.handleClick1("extendedOpenings_roofs");
                          }}
                          checked={
                            this.props.vehicalStateData.extendedOpenings_roofs
                              ? true
                              : false
                          }
                        />
                        <label
                          id="button"
                          htmlFor="extendedOpenings_roofs-checkbox"
                          className="doorinputlabel"
                        >
                          <div className="knob"></div>
                        </label>
                        <div className="lock">Open</div>
                        <div className="unlock">Close</div>
                      </div>
                    </div>
                    <h5 className="fs-6 border-bottom pb-2 mt-5 mb-3">
                      Windows
                    </h5>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Front Wheel Left (FWL)</label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.windows_FWL}
                          onChange={(value) => {
                            this.props.changeHandler(value, "windows_FWL");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.windows_FWL} %
                        </div>

                        {/* <input type="checkbox" id="windows_FWL-checkbox" className="doorinput" onClick={(e) => { this.props.handleClick1('windows_FWL') }} checked={this.props.vehicalStateData.windows_FWL ? true : false} />
                                                <label id="button" htmlFor="windows_FWL-checkbox" className="doorinputlabel">
                                                    <div className="knob"></div>
                                                </label>
                                                <div className="lock">Close</div>
                                                <div className="unlock">Open</div> */}
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Front Wheel Right (FWR)</label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.windows_FWR}
                          onChange={(value) => {
                            this.props.changeHandler(value, "windows_FWR");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.windows_FWR} %
                        </div>
                      </div>
                    </div>

                    <div className="col-3">
                      <div className="form-group">
                        <label>Rear Wheel Left (RWL)</label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.windows_RWL}
                          onChange={(value) => {
                            this.props.changeHandler(value, "windows_RWL");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.windows_RWL} %
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Rear Wheel Right (RWR)</label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.windows_RWR}
                          onChange={(value) => {
                            this.props.changeHandler(value, "windows_RWR");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.windows_RWR} %
                        </div>

                        {/* <input type="checkbox" id="windows_RWR-checkbox" className="doorinput" onClick={(e) => { this.props.handleClick1('windows_RWR') }} checked={this.props.vehicalStateData.windows_RWR ? true : false} />
                                                <label id="button" htmlFor="windows_RWR-checkbox" className="doorinputlabel">
                                                    <div className="knob"></div>
                                                </label>
                                                <div className="lock">Close</div>
                                                <div className="unlock">Open</div> */}
                      </div>
                    </div>

                    <div className="col-3">
                      <div className="form-group">
                        <label>Backdoor</label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.windows_backdoor}
                          onChange={(value) => {
                            this.props.changeHandler(value, "windows_backdoor");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.windows_backdoor} %
                        </div>
                      </div>
                    </div>

                    <div className="col-3 d-none">
                      <div className="form-group">
                        <label>Windows SunRoof (snRf)</label>
                        <Slider
                          min={0}
                          max={100}
                          value={this.props.vehicalStateData.windows_snRf}
                          onChange={(value) => {
                            this.props.changeHandler(value, "windows_snRf");
                          }}
                        />
                        <div className="value text-center">
                          {this.props.vehicalStateData.windows_snRf} %
                        </div>

                        {/* <input type="checkbox" id="windows_snRf-checkbox" className="doorinput" onClick={(e) => { this.props.handleClick1('windows_snRf') }} checked={this.props.vehicalStateData.windows_snRf ? true : false} />
                                                <label id="button" htmlFor="windows_snRf-checkbox" className="doorinputlabel">
                                                    <div className="knob"></div>
                                                </label>
                                                <div className="lock">Close</div>
                                                <div className="unlock">Open</div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="status_sections">
                  <div className="row py-3">
                    <h5 className="fs-6 border-bottom pb-2 mt-2 mb-3">
                      Rear Seat 2<sup>nd</sup> row
                    </h5>
                    <div className="col-6 mt-3">
                      <label>Left</label>
                      <div
                        className="form-group"
                        onChange={this.props.seatR2Lchanges}
                      >
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="seatrearleft"
                            checked={
                              this.props.vehicalStateData.seat_R2L ===
                              "returnwalkin"
                            }
                            id="seat_R2L_returnwalkin"
                            value="returnwalkin"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="seat_R2L_returnwalkin"
                          >
                            Returnwalkin
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="seatrearleft"
                            checked={
                              this.props.vehicalStateData.seat_R2L === "walkin"
                            }
                            id="seat_R2L_Walkin"
                            value="walkin"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="seat_R2L_Walkin"
                          >
                            Walkin
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="seatrearleft"
                            checked={
                              this.props.vehicalStateData.seat_R2L === "fold"
                            }
                            id="seat_R2L_fold"
                            value="fold"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="seat_R2L_fold"
                          >
                            Fold
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="seatrearleft"
                            checked={
                              this.props.vehicalStateData.seat_R2L ===
                              "returnfold"
                            }
                            id="seat_R2L_returnfold"
                            value="returnfold"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="seat_R2L_returnfold"
                          >
                            Returnfold
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 mt-3">
                      <label>Right</label>
                      <div className="form-group">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            onChange={this.props.seatR2Rchanges}
                            type="radio"
                            name="seatrear2right"
                            checked={
                              this.props.vehicalStateData.seat_R2R ===
                              "returnwalkin"
                            }
                            id="seat_R2R_returnwalkin"
                            value="returnwalkin"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="seat_R2R_returnwalkin"
                          >
                            Returnwalkin
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            onChange={this.props.seatR2Rchanges}
                            type="radio"
                            name="seatrear2right"
                            checked={
                              this.props.vehicalStateData.seat_R2R === "walkin"
                            }
                            id="seat_R2R_Walkin"
                            value="walkin"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="seat_R2R_Walkin"
                          >
                            Walkin
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            onChange={this.props.seatR2Rchanges}
                            type="radio"
                            name="seatrear2right"
                            checked={
                              this.props.vehicalStateData.seat_R2R === "fold"
                            }
                            id="seat_R2R_fold"
                            value="fold"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="seat_R2R_fold"
                          >
                            Fold
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            onChange={this.props.seatR2Rchanges}
                            type="radio"
                            name="seatrear2right"
                            checked={
                              this.props.vehicalStateData.seat_R2R ===
                              "returnfold"
                            }
                            id="seat_R2R_returnfold"
                            value="returnfold"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="seat_R2R_returnfold"
                          >
                            Returnfold
                          </label>
                        </div>
                      </div>
                    </div>

                    <h5 className="fs-6 border-bottom pb-2 mt-3 mb-3">
                      Rear Seat 3<sup>rd</sup> row{" "}
                    </h5>
                    <div className="col-4 mt-3">
                      <label>Left</label>
                      <div
                        className="form-group"
                        onChange={this.props.seatR3Lchanges}
                      >
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="seatrear3left"
                            checked={
                              this.props.vehicalStateData.seat_R3L === "fold"
                            }
                            id="seat_R3L_fold"
                            value="fold"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="seat_R3L_fold"
                          >
                            Fold
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="seatrear3left"
                            checked={
                              this.props.vehicalStateData.seat_R3L ===
                              "returnfold"
                            }
                            id="seat_R3L_returnfold"
                            value="returnfold"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="seat_R3L_returnfold"
                          >
                            Returnfold
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 mt-3">
                      <label>Center</label>
                      <div
                        className="form-group"
                        onChange={this.props.seatR3Cchanges}
                      >
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="seaterear3center"
                            checked={
                              this.props.vehicalStateData.seat_R3C === "fold"
                            }
                            id="seat_R3C_fold"
                            value="fold"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="seat_R3C_fold"
                          >
                            Fold
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="seaterear3center"
                            checked={
                              this.props.vehicalStateData.seat_R3C ===
                              "returnfold"
                            }
                            id="seat_R3C_returnfold"
                            value="returnfold"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="seat_R3C_returnfold"
                          >
                            Returnfold
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 mt-3">
                      <label>Right</label>
                      <div
                        className="form-group"
                        onChange={this.props.seatR3Rchanges}
                      >
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="seatrear3right"
                            checked={
                              this.props.vehicalStateData.seat_R3R === "fold"
                            }
                            id="seat_R3R_fold"
                            value="fold"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="seat_R3R_fold"
                          >
                            Fold
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="seatrear3right"
                            checked={
                              this.props.vehicalStateData.seat_R3R ===
                              "returnfold"
                            }
                            id="seat_R3R_returnfold"
                            value="returnfold"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="seat_R3R_returnfold"
                          >
                            Returnfold
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>

              <TabPanel>
                <div className="row py-3">
                  <h5 className="fs-6 border-bottom pb-2 mt-2 mb-3">
                    Target ChargeLid
                  </h5>
                  <div className="col-3">
                    <div className="form-group">
                      <input
                        type="checkbox"
                        id="tcll-checkbox"
                        className="doorinput"
                        onClick={(e) => {
                          this.props.handleClick1("tcll");
                        }}
                        checked={
                          this.props.vehicalStateData.tcll ? true : false
                        }
                      />
                      <label
                        id="button"
                        htmlFor="tcll-checkbox"
                        className="doorinputlabel"
                      >
                        <div className="knob"></div>
                      </label>
                      <div className="lock">Open</div>
                      <div className="unlock">Close</div>
                    </div>
                  </div>

                  <h5 className="fs-6 border-bottom pb-2 mt-2 mb-1">
                    Plug Info - Charge and Power Supply
                  </h5>
                  <div className="col-3">
                    <div className="form-group dropdownArrowdown">
                      <label>Status</label>
                      <select
                        value={this.props.vehicalStateData.plug_plgSts}
                        onChange={this.props.chargedropdown}
                        name="plug_plgSts"
                        className="form-control"
                      >
                        <option value="0">0 : Undefined</option>
                        <option value="12">12 : Parked</option>
                        <option value="24">24 : Running</option>
                        <option value="32">
                          32 : Power source judgment in progress
                        </option>
                        <option value="36">36 : Waiting for timer</option>
                        <option value="40">40 : Charging</option>
                        <option value="45">45 : Stop charging</option>
                        <option value="49">49 : In V2H mode</option>
                        <option value="56">56 : During fast charging</option>
                        <option value="60">60 : Fast charge stop</option>
                        <option value="64">
                          64 : Preparing for power supply
                        </option>
                        <option value="80">
                          80 : power outage/loose connection
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="row pb-3">
                  <h5 className="fs-6 border-bottom pb-2 mt-2 mb-3">
                    Charging Profile
                  </h5>
                  {/* <div className="col-3">
                                        <div className="form-group">
                                            <label title="Gasoline travelable distance unit">Profile ID</label>
                                            <input type="text" id="charge_prof_pId" className="form-control" value={this.props.vehicalStateData.charge_prof_pId} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} />
                                        </div>
                                    </div> */}
                  <div className="col-3">
                    <div className="form-group dropdownArrowdown">
                      <label title="Gasoline travelable distance unit">
                        Charge type of next timer charge
                      </label>
                      <select
                        value={this.props.vehicalStateData.charge_prof_chrgTyp}
                        onChange={this.props.chargedropdown}
                        name="charge_prof_chrgTyp"
                        className="form-control"
                      >
                        <option value="0">0 : Immediately charging</option>
                        <option value="1">1 : Set charging start time</option>
                        <option value="2">
                          2 : Set charging end time with A/C interlocking OFF
                        </option>
                        <option value="3">
                          3 : Set charging end time with A/C interlocking ON
                        </option>
                        <option value="4">
                          4 : Set charging start and end time
                        </option>
                        <option value="15">
                          15 : There is no charge reservation of next time
                        </option>
                      </select>
                    </div>
                  </div>

                  {this.props.vehicalStateData.charge_prof_chrgTyp == "1"
                    ? startTimecharge
                    : null}
                  {this.props.vehicalStateData.charge_prof_chrgTyp == "2"
                    ? endTimecharge
                    : null}
                  {this.props.vehicalStateData.charge_prof_chrgTyp == "3"
                    ? endTimecharge
                    : null}
                  {this.props.vehicalStateData.charge_prof_chrgTyp == "4"
                    ? startTimecharge
                    : null}
                  {this.props.vehicalStateData.charge_prof_chrgTyp == "4"
                    ? endTimecharge
                    : null}

                  <div className="col-3">
                    <div className="form-group">
                      <label>Active</label>
                      <input
                        type="checkbox"
                        id="charge_prof_active-checkbox"
                        className="doorinput"
                        onClick={(e) => {
                          this.props.handleClick1("charge_prof_active");
                        }}
                        checked={
                          this.props.vehicalStateData.charge_prof_active
                            ? true
                            : false
                        }
                      />
                      <label
                        id="button"
                        htmlFor="charge_prof_active-checkbox"
                        className="doorinputlabel"
                      >
                        <div className="knob"></div>
                      </label>
                      <div className="unlock">Off</div>
                      <div className="lock">On</div>
                    </div>
                  </div>
                </div>
                <div className="row pb-3">
                  <h5 className="fs-6 border-bottom pb-2 mt-2 mb-3">
                    Charging SDL
                  </h5>
                  <div className="col-3">
                    <div className="form-group dropdownArrowdown">
                      <label title="Gasoline travelable distance unit">
                        Setting Type
                      </label>
                      <select
                        value={this.props.vehicalStateData.charge_sdl_setTyp}
                        onChange={this.props.chargedropdown}
                        name="charge_sdl_setTyp"
                        className="form-control"
                      >
                        <option value="0">0 : Undefined</option>
                        <option value="1">1 : Start</option>
                        <option value="4">4 : Start & Stop</option>
                      </select>
                    </div>
                  </div>

                  {this.props.vehicalStateData.charge_sdl_setTyp == "1"
                    ? startTimeNext
                    : null}
                  {this.props.vehicalStateData.charge_sdl_setTyp == "4"
                    ? startTimeNext
                    : null}
                  {this.props.vehicalStateData.charge_sdl_setTyp == "4"
                    ? endTimeNext
                    : null}

                  {/* <div className="col-3">
                                        <div className="form-group">
                                            <label title="Gasoline travelable distance unit">Next setting ID</label>
                                            <input type="text" id="charge_sdl_setID" className="form-control" value={this.props.vehicalStateData.charge_sdl_setID} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} />
                                        </div>
                                    </div> */}
                  <div className="col-3">
                    <div className="form-group">
                      <label>Active</label>
                      <input
                        type="checkbox"
                        id="charge_sdl_active-checkbox"
                        className="doorinput"
                        onClick={(e) => {
                          this.props.handleClick1("charge_sdl_active");
                        }}
                        checked={
                          this.props.vehicalStateData.charge_sdl_active
                            ? true
                            : false
                        }
                      />
                      <label
                        id="button"
                        htmlFor="charge_sdl_active-checkbox"
                        className="doorinputlabel"
                      >
                        <div className="knob"></div>
                      </label>
                      <div className="lock">On</div>
                      <div className="unlock">Off</div>
                    </div>
                  </div>
                  <div className="col-9">
                    <div className="form-group">
                      <label title="Gasoline travelable distance unit">
                        Charging week of next timer charge
                      </label>
                      {/* <input type="text" id="charge_sdl_chrgWk" className="form-control" value={this.props.vehicalStateData.charge_sdl_chrgWk} onChange={(e) => { this.props.changeHandler(e.currentTarget.value, e.currentTarget.id) }} /> */}
                      <div className="clearfix"></div>
                      {this.props.weeks.map((data: any, index: any) => {
                        console.log("Weeks Data", data);
                        return (
                          <div
                            key={index}
                            className="form-check form-check-inline"
                          >
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="weeksname"
                              id={data.value}
                              value={data.value}
                              checked={this.props.vehicalStateData.charge_sdl_chrgWk.includes(
                                data.value,
                              )}
                              onChange={this.props.weeksOnclick}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={data.value}
                            >
                              {data.label}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <h5 className="fs-6 border-bottom pb-2 mt-2 mb-3">
                    Charge Status
                  </h5>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Charge Status</label>
                      <input
                        type="checkbox"
                        id="charge_status_swtSts-checkbox"
                        className="doorinput"
                        onClick={(e) => {
                          this.props.handleClick1("charge_status_swtSts");
                        }}
                        checked={
                          this.props.vehicalStateData.charge_status_swtSts
                            ? true
                            : false
                        }
                      />
                      <label
                        id="button"
                        htmlFor="charge_status_swtSts-checkbox"
                        className="doorinputlabel"
                      >
                        <div className="knob"></div>
                      </label>
                      <div className="lock">On</div>
                      <div className="unlock">Off</div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Remaining amount of Charge</label>
                      <Slider
                        min={0}
                        max={100}
                        value={
                          this.props.vehicalStateData.charge_status_chrgRemAmt
                        }
                        onChange={(value) => {
                          this.props.changeHandler(
                            value,
                            "charge_status_chrgRemAmt",
                          );
                        }}
                      />
                      <div className="value text-center">
                        {this.props.vehicalStateData.charge_status_chrgRemAmt} %
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Remaining time until fully charged</label>
                      <Slider
                        min={0}
                        max={65535}
                        value={
                          this.props.vehicalStateData.charge_status_remChgTm
                        }
                        onChange={(value) => {
                          this.props.changeHandler(
                            value,
                            "charge_status_remChgTm",
                          );
                        }}
                      />
                      <div className="value text-center">
                        {this.props.vehicalStateData.charge_status_remChgTm} min
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Charge Limit</label>
                      <Slider
                        min={0}
                        max={65535}
                        value={this.props.vehicalStateData.charge_chrglmt}
                        onChange={(value) => {
                          this.props.changeHandler(value, "charge_chrglmt");
                        }}
                      />
                      <div className="value text-center">
                        {this.props.vehicalStateData.charge_chrglmt} %
                      </div>
                    </div>
                  </div>
                  <div className="col-3 mt-3">
                    <div className="form-group dropdownArrowdown">
                      <label>Charge power SW</label>
                      <select
                        value={this.props.vehicalStateData.charge_chrgPwrSW}
                        onChange={this.props.chargedropdown}
                        name="charge_chrgPwrSW"
                        className="form-control"
                      >
                        <option value="AC">AC</option>
                        <option value="DC">DC</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Connector Lock Status</label>
                      <input
                        type="checkbox"
                        id="charge_status_cntLkSts-checkbox"
                        className="doorinput"
                        onClick={(e) => {
                          this.props.handleClick1("charge_status_cntLkSts");
                        }}
                        checked={
                          this.props.vehicalStateData.charge_status_cntLkSts
                            ? true
                            : false
                        }
                      />
                      <label
                        id="button"
                        htmlFor="charge_status_cntLkSts-checkbox"
                        className="doorinputlabel"
                      >
                        <div className="knob"></div>
                      </label>
                      <div className="lock">On</div>
                      <div className="unlock">Off</div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Charging Port Lid Lock Status</label>
                      <input
                        type="checkbox"
                        id="charge_status_prtLidSts-checkbox"
                        className="doorinput"
                        onClick={(e) => {
                          this.props.handleClick1("charge_status_prtLidSts");
                        }}
                        checked={
                          this.props.vehicalStateData.charge_status_prtLidSts
                            ? true
                            : false
                        }
                      />
                      <label
                        id="button"
                        htmlFor="charge_status_prtLidSts-checkbox"
                        className="doorinputlabel"
                      >
                        <div className="knob"></div>
                      </label>
                      <div className="lock">LOCK</div>
                      <div className="unlock">UNLOCK</div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Charging Port Lid State</label>
                      <input
                        type="checkbox"
                        id="charge_state_prtLidSts-checkbox"
                        className="doorinput"
                        onClick={(e) => {
                          this.props.handleClick1("charge_state_prtLidSts");
                        }}
                        checked={
                          this.props.vehicalStateData.charge_state_prtLidSts
                            ? true
                            : false
                        }
                      />
                      <label
                        id="button"
                        htmlFor="charge_state_prtLidSts-checkbox"
                        className="doorinputlabel"
                      >
                        <div className="knob"></div>
                      </label>
                      <div className="lock">OPEN</div>
                      <div className="unlock">Close</div>
                    </div>
                  </div>
                </div>

                <div className="row border-top mt-3 pt-3">
                  <div className="col-3">
                    <div className="form-group dropdownArrowdown">
                      <label title="Gasoline travelable distance unit">
                        Setting Type
                      </label>
                      <select
                        value={
                          this.props.vehicalStateData.charge_status_chrgPDF
                        }
                        onChange={this.props.chargedropdown}
                        name="charge_status_chrgPDF"
                        className="form-control"
                      >
                        <option value="1">1 : Operation Succeed</option>
                        <option value="2">
                          2 : The setting can not be changed because the vehicle
                          is charging
                        </option>
                        <option value="3">
                          3 : The setting can not be changed because the AC
                          charging connector is connected
                        </option>
                        <option value="4">
                          4 : When try to add a schedule and cannot add it
                          because the schedule maximum number has been reached
                        </option>
                        <option value="5">
                          5 : The schedule to be operated has already been
                          deleted
                        </option>
                      </select>
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="form-group dropdownArrowdown">
                      <label>Connector connection status</label>
                      <select
                        value={this.props.vehicalStateData.charge_status_cntSts}
                        onChange={this.props.chargedropdown}
                        name="charge_status_cntSts"
                        className="form-control"
                      >
                        <option value="0">0 : Undefined</option>
                        <option value="2">2 : Disconnected</option>
                        <option value="4">
                          4 : AC charging connector is connected
                        </option>
                        <option value="5">
                          5 : AC charging connector is connected and locked
                        </option>
                        <option value="6">6 : VPC</option>
                        <option value="7">7 : VPC and Locked</option>
                        <option value="8">
                          8 : DC charging connector is connected
                        </option>
                      </select>
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="form-group dropdownArrowdown">
                      <label>Timer Setting change acceptance</label>
                      <select
                        value={
                          this.props.vehicalStateData.charge_status_setChAcc
                        }
                        onChange={this.props.chargedropdown}
                        name="charge_status_setChAcc"
                        className="form-control"
                      >
                        <option value="0">0 : No change request</option>
                        <option value="1">
                          1 : In transition of setting screen of meter
                        </option>
                        <option value="2">
                          2 : In transition of setting screen of display
                        </option>
                        <option value="4">
                          4 : In transition of setting screen of meter and
                          display
                        </option>
                        <option value="5">
                          5 : Under accepting bulk changes from service tools
                        </option>
                        <option value="9">9 : Changing timer from meter</option>
                        <option value="10">
                          10 : Changing timer from display
                        </option>
                        <option value="11">11 : Changing timer from DCM</option>
                        <option value="13">
                          13 : Changing timer from service tools
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="row py-3">
                  <h5 className="fs-6 border-bottom pb-2 mb-1">Solar</h5>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Solar cumulative power generation</label>
                      <Slider
                        min={0}
                        max={16777215}
                        value={this.props.vehicalStateData.solar_solrPG}
                        onChange={(value) => {
                          this.props.changeHandler(value, "solar_solrPG");
                        }}
                      />
                      <div className="value text-center">
                        {this.props.vehicalStateData.solar_solrPG} wh
                      </div>
                    </div>
                  </div>
                  <div className="col-3 d-none">
                    <div className="form-group">
                      <label>History information</label>
                      <Slider
                        min={0}
                        max={16777215}
                        value={this.props.vehicalStateData.plug_plgHsty}
                        onChange={(value) => {
                          this.props.changeHandler(value, "plug_plgHsty");
                        }}
                      />
                      <div className="value text-center">
                        {this.props.vehicalStateData.plug_plgHsty}
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>

              <TabPanel>
                <div className="row py-3">
                  <div className="col-3">
                    <div className="form-group">
                      <label>Mechanical A/C</label>
                      <input
                        type="checkbox"
                        id="MechanicalAC-checkbox"
                        className="doorinput"
                        onClick={(e) => {
                          this.props.handleClick1("MechanicalAC");
                        }}
                        checked={
                          this.props.vehicalStateData.MechanicalAC
                            ? true
                            : false
                        }
                      />
                      <label
                        id="button"
                        htmlFor="MechanicalAC-checkbox"
                        className="doorinputlabel"
                      >
                        <div className="knob"></div>
                      </label>
                      <div className="lock">ON</div>
                      <div className="unlock">OFF</div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Extended Operation</label>
                      <input
                        type="checkbox"
                        id="ExtendedOperation-checkbox"
                        className="doorinput"
                        onClick={(e) => {
                          this.props.handleClick1("ExtendedOperation");
                        }}
                        checked={
                          this.props.vehicalStateData.ExtendedOperation
                            ? true
                            : false
                        }
                      />
                      <label
                        id="button"
                        htmlFor="ExtendedOperation-checkbox"
                        className="doorinputlabel"
                      >
                        <div className="knob"></div>
                      </label>
                      <div className="lock">ON</div>
                      <div className="unlock">OFF</div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Unlock Immobilizer</label>
                      <input
                        type="checkbox"
                        id="UnlockImmobilizer-checkbox"
                        className="doorinput"
                        onClick={(e) => {
                          this.props.handleClick1("UnlockImmobilizer");
                        }}
                        checked={
                          this.props.vehicalStateData.UnlockImmobilizer
                            ? true
                            : false
                        }
                      />
                      <label
                        id="button"
                        htmlFor="UnlockImmobilizer-checkbox"
                        className="doorinputlabel"
                      >
                        <div className="knob"></div>
                      </label>
                      <div className="lock">Enable</div>
                      <div className="unlock">Disable</div>
                    </div>
                  </div>
                </div>
              </TabPanel>

              <div className="row border-top pt-2">
                <div className="col-12 text-right">
                  <button
                    type="button"
                    className="btn btn-light btn-lg"
                    onClick={(e) => {
                      this.props.clearClick();
                    }}
                  >
                    Clear
                  </button>
                  <button type="submit" className="btn btn-primary btn-lg">
                    Save
                  </button>
                </div>
              </div>
            </Tabs>
          </form>
        </div>
      </div>
    );
  }
}

export default vehicleFormView;
